<template>
    <div class="main-cards card">
        <div class="card-header">
            <div class="headercard" style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/dashboard/armazenagemtotal.png')" alt="home" style="max-width: 3vh;">
                &nbsp;
                <h5 style="margin: 0%">Armazenagem Total</h5>
            </div>
        </div>
        <div class="card-body text-center" id="silos">
            <section class="centralized-content">
                <ProgressCircle :percentage="percentage" />
                <div class="total-info">
                {{armazenadoTotal}}/{{capacidadeTotal}} Sacas
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import ProgressCircle from '@/components/ui/ProgressCircle.vue';

export default {
    name: 'DashboardArmazenagemTotal',
    components: {
        ProgressCircle
    },
    props: {
        percentage: {
            type: Number,
            required: true
        },
        armazenadoTotal: {
            type: Number,
            required: true
        },
        capacidadeTotal: {
            type: Number,
            required: true
        }
    },
}
</script>
<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.card-header img {
    max-width: 3vh;
}

.card-body {
    position: relative;
    padding-top: 20px;
}

.card {
    margin-bottom: 0;
}

.main-cards{
    margin: 0.5rem;
    margin-bottom: 1rem;
}
</style>